import React from 'react';
import MainContainer from "./components/MainContainer";

function App() {
  return (
    <div>
      <MainContainer />
    </div>
  );
}

export default App;
